import React from 'react';

const InputValidationError = ({error}) => {
  return (
      <div className="text-center">
          <small className='text-danger'>{error}</small>
      </div>
  )
};

export default InputValidationError;
